export enum TrashType {
    Projects = "Projects",
    DailyRecords = "DialyRecords",
    Diaries = "Diaries",
    Wealths = "Wealths",
    Invoices = "Invoices",
    Todos = "Todos",
    Employees = "Employees"
}